import { UnregisterCallback } from 'history';
import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';

import { AppEventType } from '@core/events';
import { SiteLayout } from '@layouts';
import { ServerErrorView } from '@views/ServerError';

interface RootErrorHandlerProps extends RouteComponentProps {
  children?: React.ReactNode;
}

class RootErrorHandlerClass extends React.Component<
  RootErrorHandlerProps,
  { errored: boolean; errorId: string[] }
> {
  state = { errored: false, errorId: [] };
  unlisten: UnregisterCallback | undefined;

  componentDidMount() {
    this.unlisten = this.props.history.listen(() => {
      if (this.state.errored) {
        this.setState({ errored: false });
      }
    });
    addEventListener(AppEventType.GraphqlError, (evt) => {
      this.setState({ errored: true, errorId: (evt as CustomEvent)?.detail });
      // Apollo cache purge removed - using TanStack Query now
    });
    addEventListener(AppEventType.NetworkError, (evt) => {
      this.setState({
        errored: true,
        errorId: [(evt as CustomEvent)?.detail],
      });
    });
  }

  componentWillUnmount() {
    this.unlisten && this.unlisten();
  }

  componentDidCatch(error: Error) {
    console.error(error);
    this.setState({
      errored: true,
      errorId: [],
    });
  }

  render() {
    return this.state.errored ? (
      <SiteLayout nav={false}>
        <ServerErrorView backRef={false} errorId={this.state.errorId} />
      </SiteLayout>
    ) : (
      this.props.children
    );
  }
}

export const RootErrorHandler = withRouter(RootErrorHandlerClass);
